import { useState } from "react";

import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";

import FormGroup from "./FormGroup.js";
import ButtonGrid from "./ButtonGrid.js";

export default function LoginModal (props)
{
    const [validated, setValidated] = useState(false);
    const [mailAddress, setMailAddress] = useState("");
    const [password, setPassword] = useState("");
    const [rememberMe, setRememberMe] = useState(false);

    function handleMailAddressChange (e) { setMailAddress(e.target.value); }
    function handlePasswordChange (e) { setPassword(e.target.value); }

    function hide ()
    {
	props.hide();
	setMailAddress("");
	setPassword("");
	setValidated(false);
	setRememberMe(false);
    }
    
    function handleHide (e) { hide(); }

    function handleSubmit (e)
    {
	e.preventDefault();
	if (e.target.checkValidity()) {
	    props.submit({ mailAddress, password, rememberMe });
	    hide();
	}

	else setValidated(true);
    }

    function handleRememberMeChange (e)
    {
	setRememberMe(!rememberMe);
    }

    return (
	<Modal
	    size="md"
	    show={props.show}
	    onHide={handleHide}
	    centered
	>
	    <Modal.Header>
		<Modal.Title>Connexion</Modal.Title>
	    </Modal.Header>
	    <Modal.Body>
		<Form
		    id="loginForm"
			noValidate validated={validated}
			onSubmit={handleSubmit}
		    className="d-flex flex-column gap-3"
		>
		    <FormGroup sm={5} formID="loginForm" controlID="mailAddress" label="Adresse courriel">
			<Form.Control
			    type="text"
			    required
			    value={mailAddress}
			    onChange={handleMailAddressChange}
			/>
		    </FormGroup>

		    <FormGroup sm={5} formID="loginForm" controlID="password" label="Mot de passe">
			<Form.Control
			    type="password"
			    required
			    value={password}
			    onChange={handlePasswordChange}
			/>
		    </FormGroup>

		    <FormGroup sm={5} formID="loginForm" controlID="rememberMe">
			<Form.Check
			    type="checkbox"
			    label="Se souvenir de moi"
			    checked={rememberMe}
			    onChange={handleRememberMeChange}			
			/>
		    </FormGroup>

		</Form>
	    </Modal.Body>
	    
	    <Modal.Footer>
		<ButtonGrid>
		    <ButtonGrid.Left>
			<Button variant="outline-secondary" size="md" onClick={handleHide}>Annuler</Button>
		    </ButtonGrid.Left>
		    <ButtonGrid.Right>
			<Button variant="primary" size="md" type="submit" form="loginForm">Se connecter</Button>
		    </ButtonGrid.Right>
		</ButtonGrid>
	    </Modal.Footer>
	</Modal>
    );
}
